import { Category } from 'domains/category';
import { CategoryResponseDTO } from 'infrastructure/dtos/category';

export class CategoryMapper {
  static fromDTO(categoryResponseDTO: CategoryResponseDTO): Category {
    let children: Category[] | undefined = [];

    if (categoryResponseDTO.children) {
      children = categoryResponseDTO.children.map(CategoryMapper.fromDTO);
    }

    return new Category(categoryResponseDTO.id, categoryResponseDTO.name, children);
  }
}
